import { User } from '@/@types/user';
import { Table } from '@/components/common';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';

export interface IUsersTableProps {
  data: User[];
  columns: ColumnDefinitionType<User>[];
  sort?: 'desc' | 'asc';
  sortBy?: keyof User;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
}

export function UsersTable({
  data,
  columns,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: IUsersTableProps) {
  return (
    <Table
      data={data}
      columns={columns}
      additionalData={actions}
      sort={sort}
      sortBy={sortBy}
      onSort={onSort}
      pagination={pagination}
    />
  );
}
